import { apiUrls } from './_environment-api-urls';

export const environment = {
  apiUrl: 'https://api.quotemanagerpro.com/',
  companyDataUrl: 'assets/companies/',
  defaultBrandClass: 'brand-default',
  defaultBrandId: 'firstco',
  defaultBrandName: 'ae-air',
  defaultLogoImagePath: 'assets/company/default/ae-air-logo-main.png',
  production: true,
  apiUrls,
  inactivityTimeout: 901,//15 * 60, //seconds
  enableCorePerformance: false,
  aiFlowUrl: 'https://044ea766a715edd8a3b115ec0f25a2.14.environment.api.powerplatform.com/powerautomate/automations/direct/cu/17/workflows/0b6a72a3e3d24229a06e35b13dbad874/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=LhPuXhVoW2w1tVT2ViuJIErVqr__QNxHjv6DHEoq-WE'
};
